var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVollmachtBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Vollmacht_White",
    "data-name": " Vollmacht_White",
    d: "M204.185,272.328l-2.288-2.019.708-3.1-3.162-.3-1.247-3-2.521,1.652-2.57-1.653-1.242,3.06-3.14.322.724,3.057-2.263,2.031,2.357,2.159-.684,3.259,3.026.224,1.14,2.889,2.669-1.678,2.72,1.678,1.135-2.947,3.005-.249-.7-3.214Zm-5.827-2.729-3.345,6.142a.146.146,0,0,1-.23.048l-2.312-2.021a.22.22,0,0,1-.039-.27l.189-.322a.171.171,0,0,1,.266-.051l1.653,1.436a.177.177,0,0,0,.278-.059l2.919-5.377a.218.218,0,0,1,.324-.087l.216.154A.322.322,0,0,1,198.358,269.6Z",
    transform: "translate(-187.185 -263.911)",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVollmachtBlack);
export default __webpack_public_path__ + "static/media/icon_vollmacht_black.bfc4509d9c3a326cca5890cd0e83cfcb.svg";
export { ForwardRef as ReactComponent };